import {SurveyData} from "./data.js";
import { reactive } from 'vue';

// function disableScroll() {
//     // console.log("disable");
//     let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
//     window.onscroll = function () {
//         window.scrollTo(scrollLeft, scrollTop);
//     };
// }
function enableScroll() {
    // console.log("enable");
    window.onscroll = function () { };
}

const store = {
    debug:false,
    state: reactive({
        user:{},
        totals:null,
        currentQ:0,
        previousQ:0,
        uniqueAnswers: {},
        questionData:{},
        surveyAnswers:{},
        trackerVal: [0,18],
        benchmark:[],
        finished:[],
        paramsBool: true,
        showModal: false,
    }),
    // showModal(modal, data = null) {
    //     // console.log(data)
    //     this.state.showModal = true;
    //     this.state.selectedModal = {
    //         "title": "Small Sample Warning",
    //         "text": "<p>With 100 or fewer employees, the data generated by this form will be less relevant.</p>"
    //     }
    //     disableScroll();
    // },
    hideModal() {
        this.state.showModal = false;
        enableScroll();
    },

    buildBenchmark(arr){ 
        const totals = [0,0,0,0,0,0,0,0]
        const newBenchmark = [
            [[0,0],[0,0],[0,0]],//q11,0
            [[0,0,0,0]],//q12,1
            [[0,0,0,0,0]],//q13,2
            [[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0]],//q14,3
            [[0,0,0,0,0,0,0,0,0],[0]],//q16,4
            [[0,0,0,0],[0,0,0,0],[0,0,0,0],[0,0,0,0],[0,0,0,0],[0,0,0,0],[0,0,0,0]],//q17,5
            [[0,0,0,0,0,0]],//18,6
            [[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]],//19,7
            [0,0],//q20,8
            [0,0,0]//q21,9
        ]
        
        for(let x of arr) {
    
            for(let y in x) {
    
      if((y == "q11") && (x[y])){
        totals[0]++
        x[y].split(',').map((x,i)=>newBenchmark[0][x][i]++)
      }
      if((y == "q12") && (x[y])){
        // console.log('x[y]')
        // 
        totals[1]++
        x[y].split(',').map((x)=>newBenchmark[1][0][x]++)
      }
      if((y == "q13") && (x[y])){
        // console.log('x[y]')
        // 
        totals[2]++
        x[y].split(',').map((x)=>newBenchmark[2][0][x]++)
      }
      if((y == "q14") && (x[y])){
        // console.log('x[y]')
        newBenchmark[3][1][0]++ 
        x[y].split(',').map((x)=>newBenchmark[3][0][x]++)
      }
      if((y == "q16") && (x[y])){
        // console.log('x[y]')
        newBenchmark[4][1][0]+= 1
        x[y].split(',').map((x)=>newBenchmark[4][0][x]++)
      }
      if((y == "q17") && (x[y])){
        // console.log(x[y])
        totals[3]++
        x[y].split(',').map((x,i)=>newBenchmark[5][x][i]++)
      }
      if((y == "q18") && (x[y])){
        // console.log('x[y]')
        // 
        totals[4]++
        x[y].split(',').map((x)=>newBenchmark[6][0][x]++)
      }
      if((y == "q19") && (x[y])){
        // console.log(x[y])
        totals[5]++
        x[y].split(',').map((x,i)=>newBenchmark[7][x][i]++)
      }
      if((y == "q20") && (x[y])){
        // console.log(x[y])
        totals[6]++
        x[y].split(',').map((x)=>newBenchmark[8][x]++)
      }
      if((y == "q21") && (x[y])){
        // console.log(x[y])
        totals[7]++
        x[y].split(',').map((x)=>newBenchmark[9][x]++)
      }
            }
        }
        this.state.totals = totals
        return newBenchmark
    },
    
    updateCurrentQ(val){
        // let tempArr = Object.values(this.state.finished) // get finished questions

        if (this.state.finished.includes(val)==false) this.state.finished.push(val) ; // if current question isnt in list of completed, add it
        if ([7,8,9].includes(val) && (this.state.finished.includes(9) ? true : this.state.finished.includes(8) ? true : this.state.finished.includes(7) ? true:false)) this.state.finished[this.state.finished.indexOf(6)+1] = val; 
        this.state.previousQ = this.state.finished[ this.state.finished.findIndex( ele => ele == val)-1 ] // previous is the index of current -1
        // console.log("previous:", this.state.previousQ )
        this.state.currentQ = val 
        this.state.questionData = SurveyData.find(x=> x.ID == val) // set question data to the desired ID value
    },
    updateSurveyAnswers(str1,str2){
        let obj = this.state.surveyAnswers
        obj[str1] = str2
        this.state.surveyAnswers = obj
        // console.log(str1,str2,this.state.surveyAnswers)
    },
    // filterPreviousQ(current,previousQ) {
    //     let temp =
    // }
    getURIInfo(obj){
        return {
            11:Object.values(obj["Q11"]).toString(),
            12:obj["Q12"].toString(),
            13:obj["Q13"].toString(),
            14:Object.values(obj["Q14"]).toString(),
            16:Object.values(obj["Q16"]).toString(),
            17:Object.values(obj["Q17"]).toString(),
            18:obj["Q18"].toString(),
            19:Object.values(obj["Q19"]).toString(),
            20:obj["Q20"].toString(),
            21:obj["Q21"].toString(),
        }
        
    },
    loadFromURI(arr){

        let [Q11,Q12,Q13,Q14,Q16,Q17,Q18,Q19,Q20,Q21] = arr

        store.state.surveyAnswers = {
            "Q11":Q11,
            "Q12":Q12,
            "Q13":Q13,
            "Q14":Q14,
            "Q16":Q16,
            "Q17":Q17,
            "Q18":Q18,
            "Q19":Q19,
            "Q20":Q20,
            "Q21":Q21

        }

    },
    async getSurveys() {
        {
            let submiturl =
              window.location.protocol +
              "//" +
              window.location.host + 
              "/survey/getsurveys"; //mail
            const response = await fetch(submiturl, {
              method: "get",
              mode: "no-cors",
              cache: "no-cache",
              headers: {
                "Content-Type": "application/json",
                // __RequestVerificationToken: document.getElementsByName(
                //   "__RequestVerificationToken"
                // )[0].value,
              },
              // body: JSON.stringify({resultsLink: url, email: email}),
            //   body: JSON.stringify({
            //     toAddress: email,
            //     templateName: "MSD_Survey_Results",
            //     tokens: {
            //       FirstName: this.user.firstName,
            //       SurveyLink:
            //         url,
            //     },
            //   }),
        }).then(function (response) {
            // console.log("api response", JSON.stringify(response.body));
            return response.json()
          })//.then((data) => console.log("results",data));
          return response;
        }},
    updateTracker(val){

        this.state.trackerVal[0] = Object.values(this.state.surveyAnswers).length
        // console.log("tracked:", this.state.trackerVal[0], this.state.trackerVal[1])
        if([7,8,9,15].includes(val)){
            this.state.trackerVal[1]++
        }
        if(val == 23) {
          this.state.trackerVal[0] = this.state.trackerVal[1]
        }
    },
    onUniqueAnswer(question, answer){
        this.state.uniqueAnswers[`q${question}`] = answer
        // console.log(this.state.uniqueAnswers)
    },
    processData100b(arr){
        let mid = Math.floor(arr.length / 2)
        let total = arr.reduce((x, y) => x + y, 0)
        return arr.map(x => (x / total) * 100).map((x, i) => i < mid ? -x : x)
         
    }
}


export default store;